import { actionDeclarer } from '../services/actionDeclarer';

export const {
	SET_AGENCY,
	SET_AGENCY_LIST,
	SET_AGENCY_LOCATIONS,
	SET_AGENCY_TYPES,
	SET_COORDINATION,
	SET_COORDINATION_OPTIONS,
	SET_AGENCY_STAFF,
	SET_COUNTY_OPTIONS,
	SET_SERVICE_OPTION_GROUPS,
	SET_SERVICE_OPTIONS,
	SET_TABLE_STATE
} = actionDeclarer;

const agenciesReducer = (
	state,
	{
		type,
		payload
	}
) => {
	switch ( type ) {
		case SET_AGENCY:
			return {
				...state,
				agency: payload
			};
		case SET_AGENCY_LIST:
			return {
				...state,
				agencyList: payload
			};
		case SET_AGENCY_LOCATIONS:
			return {
				...state,
				agency: {
					...state.agency,
					locations: payload
				}
			};
		case SET_AGENCY_TYPES:
			return {
				...state,
				agencyTypes: payload
			};
		case SET_COORDINATION:
			return {
				...state,
				agency: {
					...state.agency,
					coordinators: payload
				}
			};
		case SET_COORDINATION_OPTIONS:
			return {
				...state,
				coordinationOptions: payload
			};
		case SET_AGENCY_STAFF:
			return {
				...state,
				agency: {
					...state.agency,
					staff: payload
				}
			};
		case SET_COUNTY_OPTIONS:
			return {
				...state,
				countyOptions: payload
			};
		case SET_SERVICE_OPTION_GROUPS:
			return {
				...state,
				serviceOptionGroups: payload
			};
		case SET_SERVICE_OPTIONS:
			return {
				...state,
				serviceOptions: payload
			};
		case SET_TABLE_STATE:
			return {
				...state,
				tableState: payload( state.tableState )
			};
		default:
			return state;
	}
};

export default agenciesReducer;
